module.exports = __webpack_public_path__ + "img/16_47.e4ad6b83.png";